import React, { Component } from "react";
import "./bulk-upload.styles.css";
import { selectUserData } from "../../redux/user/user.selectors";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter, Switch as RouteSwitch } from "react-router-dom";

import BulkUploadPage from "./bulk-upload.page";
import BulkUploadExcelPage from "./bulk-upload-excel.page";
import UploadSummaryPage from "./upload-summary.page";
import {
  selectScreenName,
  selectScreenType,
} from "../../redux/arrival-entry/arrival-entry.selectors";
import {
  setScreenName,
  setScreenType,
} from "../../redux/arrival-entry/arrival-entry.actions";
import UploadSuccessPage from "./upload-success.page";

/**
 * @component
 * @description The parent component for Bulk upload screen page.
 *
 *
 */
class BulkUploadScreen extends Component {
  state = {
    isSpinnerOn: false,
  };

  render() {
    const { screenName, screenType } = this.props;
    // const onclickchange = (key) => {
    //   this.setState({ screenName: 2, screenType: key });
    // };
    return screenName == 2 ? (
      <BulkUploadExcelPage />
    ) : screenName == 3 ? (
      <UploadSummaryPage />
    ) : screenName == 4 ? (
      <UploadSuccessPage />
    ) : (
      <BulkUploadPage />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setScreenName: (screenName) => dispatch(setScreenName(screenName)),
    setScreenType: (type) => dispatch(setScreenType(type)),
  };
};

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  screenName: selectScreenName,
  screenType: selectScreenType,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BulkUploadScreen),
);
